// types.tsx — Compras (Purchases) section shared types

// ─── Core purchase record (single source of truth) ───────────────────────

export type TaxType = 'no_recuperable' | 'no_deducible_iva' | 'deducible_iva';

export interface TaxTypeOption {
  value: TaxType;
  label: string;
  description: string;
}

export const TAX_TYPE_OPTIONS: TaxTypeOption[] = [
  { value: 'no_recuperable', label: 'No recuperable', description: 'Sin deducción tributaria' },
  { value: 'no_deducible_iva', label: 'Boleta (sin IVA)', description: 'Deducible de renta, no de IVA' },
  { value: 'deducible_iva', label: 'Factura (con IVA)', description: 'Deducible de renta e IVA' },
];

export interface IngredientPurchaseRecord {
  ingredient_purchase_id: number;
  invoice_id: number | null;
  ingredient_id: number | null;
  ingredient_name: string | null;
  provider_id: number | null;
  provider_name: string | null;
  local_id: number;
  user_id: number | null;
  quantity: number;
  total_neto: number;
  unit_price: number;
  purchase_date: string | null;
  timestamp: string;
  unidad_medida_id: number;
  unidad_medida_name: string | null;
  unidad_medida_acronym: string | null;
  brand_id: number | null;
  brand_name: string | null;
  tax_type: TaxType | null;
  tax_amount: number | null;
  total_with_tax: number | null;
  expense_category_id: number | null;
  expense_category_name: string | null;
  notes: string | null;
}

// ─── Expense categories ──────────────────────────────────────────────────

export interface ExpenseCategoryType {
  expense_category_id: number;
  local_id: number;
  category_name: string;
  parent_category_id?: number | null;
  category_description: string;
  subcategories?: ExpenseCategoryType[];
}
 
  ///// ####### subcateogry ya no va!!!! #######
  // una subcategoria, tiene una llave foranea a una categoria a la cual pertenece, y permite agrupar gastos dentro de una misma categoria
 
// Interfaz para representar un ítem dentro de un gasto
// Esta es una Tabla de interseccion, que relaciona un gasto (expense_id) con un item (item_id)
export interface ItemExpenseType {
    item_expense_id: number; // ID único del ítem dentro del gasto
    expense_id: number; // ID del gasto al que pertenece este ítem
    item_id: number; // ID del ítem específico (por ejemplo, "Carne de res")
    quantity: number; // Cantidad del ítem
    unidad_medida_id: number; // ID de la unidad de medida (por ejemplo, "kg", "litros")
    price: number; // Precio del ítem (por unidad o total, según la lógica)
    tax: number;
    price_with_tax: number;
  }
 
  // Interfaz para representar un ingrediente dentro de un gasto
  // Esto es una tabla de interseccion, que relaciona un gasto (expense_id) con un ingrediente (ingredient_id)
export interface IngredientExpenseType {
    ingredient_expense_id: number; // ID único del ingrediente dentro del gasto
    expense_id: number; // ID del gasto al que pertenece este ingrediente
    ingredient_id: number; // ID del ingrediente específico (por ejemplo, "Tomate", "Harina")
    quantity: number; // Cantidad del ingrediente utilizado
    unidad_medida_id: number; // ID de la unidad de medida (por ejemplo, "kg", "litros")
    price: number; // Precio del ingrediente (por unidad o total)
    tax: number;
    price_with_tax: number;
  }
 
// Esto es una tabla de interseccion, que relaciona un gasto (expense_id) con un utility (utility_id)
  export interface UtilityExpenseType {
    utility_expense_id: number; // ID único del ingrediente dentro del gasto
    expense_id: number; // ID del gasto al que pertenece este ingrediente
    utility_id: number; // ID del ingrediente específico (por ejemplo, "Tomate", "Harina")
    quantity: number; // Cantidad del ingrediente utilizado
    unidad_medida_id: number; // ID de la unidad de medida (por ejemplo, "kg", "litros")
    price: number; // Precio del ingrediente (por unidad o total)
    tax: number;
    price_with_tax: number;
  }
 
  // types.tsx
 
  export interface LocalExpenseType {
    expense_id: number; // ID único del gasto (opcional)
    expense_name: string;
    local_id: number; // ID del local donde ocurrió el gasto
    user_id: number; // ID del usuario que registró el gasto
    user_name: string; // Nombre del usuario que registró el gasto
    expense_category_id: number; // ID de la categoría del gasto
    provider_id?: number; // ID del proveedor asociado al gasto (opcional)
    provider_name?: string; // Nombre del proveedor asociado al gasto (opcional)
    notes?: string; // Notas o detalles adicionales ingresados por el usuario (opcional)
    expense_category_name: string; // Nombre de la categoría del gasto
    amount: number; // Monto total del gasto
    payed?: boolean; // Indica si el gasto ha sido pagado (opcional)
    expiration_date?: string; // Fecha de vencimiento del gasto en formato ISO (opcional)
    hasIngredients?: boolean; // Indica si el gasto incluye ingredientes (opcional)
    hasUtilities?: boolean; // Indica si el gasto incluye servicios o utilidades (opcional)
    isRecurrent?: boolean; // Indica si el gasto es recurrente (opcional)
    frequency?: number; // Número de días de repetición del gasto (opcional)
    attached_files?: string; // Archivos adjuntos como cadena en formato JSON o URL (opcional)
    local_timestamp?: string; // Timestamp en la zona horaria local del cliente (opcional, formato ISO)
    timestamp?: string; // Timestamp en la zona horaria del servidor (opcional, formato ISO)
    items?: Composition[];
    ingredients?: Composition[];
    utilities?: Composition[];
    template_name: string | null; // Nombre de la plantilla utilizada en el gasto
  }
  
  
   
export interface Composition  {
    id: number;
    unidad_medida_id: number;
    price: number;
    quantity: number;
    note: string | null;
}

/** Interfaz para un impuesto individual */
export interface ExpenseTax {
  country_tax_id: number;   // ID único del impuesto (ej: 1)
  tax_name: string;         // Nombre del impuesto (ej: "IVA")
  tax_percentage: number;   // Porcentaje del impuesto (ej: 19.0)
  amount_before_tax: number; 
  amount_after_tax: number; 
}

export interface ExpenseExtra {
  extra_id?: number; // Identificador único (opcional)
  name: string;      // Nombre o descripción del extra
  amount: number;    // Monto del extra
}

 
export interface ExpenseCreationPayload {
    local_id: number; // ID del local donde ocurrió el gasto
    user_id: number; // ID del usuario que registró el gasto
    notes: string | null; 
    provider_id: number | null; // ID del proveedor asociado al gasto
    expense_name: string; // Nombre del gasto
    is_template: boolean; // Indica si el gasto utiliza una plantilla
    template_name: string | null; // Nombre de la plantilla utilizada en el gasto
    expense_category_id: number | null; // ID de la categoría del gasto
    category_name: string | null; // Nombre de la categoría del gasto
    amount: number; // Monto total del gasto
    payed: boolean; // Indica si el gasto ha sido pagado
    payment_date: string | null; // Fecha de pago del gasto
    expiration_date: string | null; // Fecha de vencimiento del gasto
    hasItems: boolean; // Indica si el gasto incluye ítems
    hasProducts?: boolean;
    items?: Composition[] | null; // Lista de ítems incluidos en el gasto
    products?: Composition[] | null;
    hasIngredients: boolean; // Indica si el gasto incluye ingredientes
    ingredients?: Composition[] | null; // Lista de ingredientes incluidos en el gasto
    hasUtilities: boolean; // Indica si el gasto incluye servicios o utilidades
    utilities?: Composition[] | null; // Lista de servicios o utilidades incluidos en el gasto
    isRecurrent?: boolean; // Indica si el gasto es recurrente
    frequency?: number | null; // Número de días de repetición del gasto
    attached_files: File[] | null; // Archivo asociado al gasto (factura, recibo, etc.)
    local_timestamp: string; // Timestamp en la zona horaria local del cliente
    timestamp: string; // Timestamp en la zona horaria del servidor
    taxes?: ExpenseTax[] | null;
    extras?: ExpenseExtra[] | null;
    discount?: string;
}

// Interface for an individual item in the invoice
export interface InvoiceItem {
  item_id: string;            // Unique identifier for each item
  codigo: string;
  detalle: string;
  cantidad: number;
  unidad: string;
  unidadInteres: string;
  cantidadInteres: number;
  Iva: number | null;
  costoUnitario: number;
  neto: number;
  descuentoPorcentaje: number;
  descuento: number;
  transporte: number;
  extras: number | null;
  categoria: string;
}

// Interface for the invoice which includes a list of items
export interface Invoice {
  invoice_id: string;         // Unique identifier for the invoice
  proveedor: string;
  rut: string;
  fecha: string;
  total: number;
  neto: number;
  iva: number;
  extras: number;
  transporte: number;
  descuentos: number;
  folio: string;
  timestamp: string;          // Timestamp of the invoice creation or processing
  detalleItems: InvoiceItem[];
}
 